module.exports = __webpack_public_path__ + "static/media/zvony1.ad33e660.jpg";